import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { PPAInvoice } from "../../PPAInvoicePage.types";

export function getInvoiceNumberColumn(): MRT_ColumnDef<PPAInvoice> {
  return {
    accessorKey: "invoice_number",
    header: "Rechnungsnummer",
    filterVariant: "text",
    size: 200
  };
}
